<template>
  <div class="pagination__pagination">
    <PaginationBullet v-for="index in view.maxCount"
                      :key="index + '_' + view.counter"
                      :active="index <= view.counter"
                      :index="index"
                      @changePage="changePage(index)" />
  </div>
</template>

<script>

import { useViewStore } from '@/stores/view';
import PaginationBullet from '@/components/PaginationBullet.vue';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Pagination',
  components: {
    PaginationBullet,
  },
  methods: {
    changePage(index) {
      if (index < this.view.maxCount) {
        switch (index) {
          case 1:
            this.view.update('NameEntry', index);
            break;
          case 2:
            this.view.update('AddressEntry', index);
            break;
          case 3:
            this.view.update('ContactDataEntry', index);
            break;
          case 4:
            this.view.update('ReclamationEntry', index);
            break;
          case 5:
            this.view.update('DeliveryEntry', index);
            break;
          default:
            break;
        }
      }
    },
  },
  setup() {
    const view = useViewStore();
    return {
      view,
    };
  },
};
</script>
